import Icon from '../components/Icon.vue'

Icon.register({
  'phone-square': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M400 32H48C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H400C426.5 480 448 458.5 448 432V80C448 53.5 426.5 32 400 32zM94 416C87 416 80.9 411.1 79.4 404.4L64.4 339.4A15-15 0 0 0 73.1 322.2L143.1 292.2A15-15 0 0 0 160.6 296.5L191.6 334.4C240.6 311.4 279.9 271.5 302.4 223.6L264.5 192.6A15-15 0 0 0 260.2 175.1L290.2 105.1A15-15 0 0 0 307.4 96.4L372.4 111.4A15-15 0 0 0 384 126C384 286.3 254.1 416 94 416z'
      }
    ]
  }
})
